import getCommonParameters from './getCommonParameters';

export * from './getCommonParameters';
export default getCommonParameters;
